import React, { Fragment } from "react";
import ApplicationForm from "../components/ApplicationForm";
import UserHead from "../components/UserHead";



function UserHome(){

    
   
    return (
        <Fragment>

            <UserHead/>
            <ApplicationForm/>
        </Fragment>
    )
}

export default UserHome;